import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import QRCode from 'react-qr-code';

export default class ComponentToPrint extends React.Component {

  render() {
    const qRcodeData = this.props.qRTagsDetailsList;
    const isPrint = this.props.isPrint;

    return (

      <table className="display dataTable no-footer">
        {
          qRcodeData.map((d, i, e) => {
            return (
              <div key={i} style={{ pageBreakBefore: "always" }}>
                <div style={{ textAlign: "center" }}>
                  <center>
                    <img src="/static/cargills-agri-logo01.png" alt="login" />
                  </center>
                </div>
                <div><center><h1>{d.tagNo}</h1></center></div>
                {isPrint.isActive == true && <div className="col-sm p-3" style={{ marginTop: 20, textAlign: "center" }} >
                  <QRCode value={d.tagNo} size={800} />
                </div>}
                {isPrint.isActive == false && <div className="col-sm p-3" style={{ marginTop: 20 }}>
                  <QRCode value={d.tagNo} size={800} />
                </div>}

              </div>
            )
          })
        }
      </table>

    );
  }
}
